export default "__VITE_ASSET__CFhDM2rM__"